export interface IMDialogWorkgroup {
  NO_SKUPINY: number;
  NAZEV: string;
}
